import React, {useState} from 'react'
import Select, {GroupBase, Props} from 'react-select'
import {selectMessages} from './selectMessages'

// Menus escape scrolling panels, but stay inside a modal's focus trap.
export default function EducationSelect<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(props: Props<Option, IsMulti, Group>) {
  const [portal, setPortal] = useState<HTMLElement>(document.body)
  return <Select {...selectMessages} {...props}
    className={props.className || 'kidly-select'} classNamePrefix={props.classNamePrefix || 'kidly'}
    menuPortalTarget={portal} menuPosition='fixed' menuPlacement='auto'
    onFocus={event => {
      setPortal(event.target.closest<HTMLElement>('.modal') || document.body)
      props.onFocus?.(event)
    }}
    styles={{...props.styles, menuPortal: (base, state) => Object.assign({}, props.styles?.menuPortal?.(base, state) || base, {zIndex: 1090})}}
  />
}
